import {UserDto} from "../../api/psc.ts";
import {Box, Button, Chip, Icon, Stack} from "@mui/material";
import ConstantChip from "../../components/ConstantChip";
import {UserStatusDefinitions} from "../../constants/UserConstantDefinitions";
import {useNavigate} from "react-router-dom";

export default function UserListItem(props: { user: UserDto }) {

    const navigate = useNavigate()

    const statusDefinition = UserStatusDefinitions.find(d => d.id === props.user.status)

    const toToEditUser = () => {
        navigate("/user/update/" + props.user.id)
    }

    return <Stack direction='row' justifyContent='space-between' alignItems='center' gap={2}>
        {props.user.fullName}
        <ConstantChip definition={statusDefinition} />
        <Box flexGrow={1} />
        <Button size='small' variant='outlined' startIcon={<Icon>edit</Icon>} onClick={toToEditUser}>ویرایش</Button>
    </Stack>
}
